export class InvoiceAmount {
  currency: string;
  unitAmount: number;
  htAmount?: number;
  vatAmount?: number;
  vatRate?: number;
  ttcAmount?: number;

  constructor(values= {}) {
    Object.assign(this, values);
  }
}
